import { c as _c } from "react/compiler-runtime";
import { Tooltip } from "react-tooltip";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import type { RatingsSectionProps, RatingsData } from "./types";
import VoteBreakdownTooltip from "./tooltips/VoteBreakdownTooltip";
import DropVoteProgressing from "@/components/drops/view/utils/DropVoteProgressing";
import { WAVE_VOTE_STATS_LABELS, WAVE_VOTING_LABELS } from "@/helpers/waves/waves.constants";
interface ParticipationDropRatingsTotalSectionProps extends RatingsSectionProps {
  readonly ratingsData: RatingsData;
}
export default function ParticipationDropRatingsTotalSection(t0) {
  const $ = _c(27);
  const {
    drop,
    theme,
    ratingsData
  } = t0;
  const {
    currentRating
  } = ratingsData;
  const t1 = `tw-relative tw-inline-flex tw-items-baseline tw-gap-x-1 ${theme.indicator}`;
  const t2 = `tw-text-sm tw-font-semibold tw-text-iron-50 ${theme.text}`;
  const t3 = currentRating < 0 && "-";
  let t4;
  if ($[0] !== currentRating) {
    t4 = formatNumberWithCommas(Math.abs(currentRating));
    $[0] = currentRating;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] !== t2 || $[3] !== t3 || $[4] !== t4) {
    t5 = <span className={t2}>{t3}{t4}</span>;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const t6 = `total-rating-${drop.id}`;
  const t7 = WAVE_VOTING_LABELS[drop.wave.voting_credit_type];
  let t8;
  if ($[6] !== t6 || $[7] !== t7) {
    t8 = <span className="tw-text-sm tw-font-normal tw-text-iron-400 tw-cursor-help" data-tooltip-id={t6}>{WAVE_VOTE_STATS_LABELS.TOTAL}{" "}{t7}</span>;
    $[6] = t6;
    $[7] = t7;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  const t9 = `total-rating-${drop.id}`;
  let t10;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      backgroundColor: "#1F2937",
      color: "white",
      padding: "4px 8px"
    };
    $[9] = t10;
  } else {
    t10 = $[9];
  }
  let t11;
  if ($[10] !== drop || $[11] !== ratingsData) {
    t11 = <VoteBreakdownTooltip drop={drop} ratingsData={ratingsData} />;
    $[10] = drop;
    $[11] = ratingsData;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] !== t11 || $[14] !== t9) {
    t12 = <Tooltip id={t9} style={t10}>{t11}</Tooltip>;
    $[13] = t11;
    $[14] = t9;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  let t13;
  if ($[16] !== t12 || $[17] !== t5 || $[18] !== t8) {
    t13 = <span>{t5}{" "}{t8}{t12}</span>;
    $[16] = t12;
    $[17] = t5;
    $[18] = t8;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== currentRating || $[21] !== drop.rating_prediction) {
    t14 = <DropVoteProgressing current={currentRating} projected={drop.rating_prediction} />;
    $[20] = currentRating;
    $[21] = drop.rating_prediction;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] !== t1 || $[24] !== t13 || $[25] !== t14) {
    t15 = <div className="tw-flex tw-items-center tw-gap-x-1"><div className={t1}>{t13}{t14}</div></div>;
    $[23] = t1;
    $[24] = t13;
    $[25] = t14;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  return t15;
}